import React, { useState, useEffect, useRef } from "react";
import { bool, string, object, func, any, node, number } from "prop-types";
import Slider from "react-slick";

import "./carousel.m.css";
import ArrowLeftIcon from "../icons/left-arrow-icon";
import ArrowRightIcon from "../icons/arrow-right";

const Carousel = ({ children, options, totalItems, showArrows, showBullets, currentIndex, setCurrentIndex }) => {
  if (!children) {
    return null;
  }

  const sliderRef = useRef(null);

  const [currentSlide, setCurrentSlide] = useState(currentIndex);

  const config = {
    arrows: false,
    dots: false,
    infinite: true,
    className: "center",
    centerPadding: "60px",
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    beforeChange: (current) => setCurrentSlide(current),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ],
    ...options
  };

  useEffect(() => sliderRef && sliderRef.current.slickGoTo(currentIndex), [currentIndex]);

  useEffect(() => setCurrentIndex && setCurrentIndex(currentSlide), [currentSlide]);

  const renderChildren = () => {
    return children.map((child, index) => {
      return (
        <li key={index} className="glide__slide">
          {child}
        </li>
      );
    });
  };

  const nextSlide = () => sliderRef.current.slickNext();

  const previousSlide = () => sliderRef.current.slickPrev();

  const goToSlide = (index) => () => {
    sliderRef.current.slickGoTo(index);
  };

  const renderGlideArrows = () => {
    return (
      <div className="glide__arrows" styleName="arrow-wrapper">
        <div
          onClick={previousSlide}
          styleName={currentSlide === 0 ? "arrow-disabled arrow-icon-wrapper" : "arrow-icon-wrapper"}
        >
          <ArrowLeftIcon />
        </div>
        {showBullets && totalItems > 1 && renderBullets()}
        <div
          onClick={nextSlide}
          styleName={currentSlide >= totalItems - 1 ? "arrow-disabled arrow-icon-wrapper" : "arrow-icon-wrapper"}
        >
          <ArrowRightIcon />
        </div>
      </div>
    );
  };

  const renderBullets = () => {
    return (
      <div styleName="indicators" className="indicators">
        {Array(totalItems)
          .fill(1)
          .map((item, index) => (
            <div
              key={index}
              styleName={`indicator-button ${currentSlide === index ? "active" : ""}`}
              onClick={goToSlide(index)}
            />
          ))}
      </div>
    );
  };

  return (
    <div className="slider" styleName="slider-wrapper">
      <Slider ref={sliderRef} {...config}>
        {renderChildren()}
      </Slider>

      <div className="arrow-with-bullets">{showArrows && totalItems > 1 && renderGlideArrows()}</div>
    </div>
  );
};

Carousel.propTypes = {
  carouselName: string,
  children: any,
  options: object,
  totalItems: number,
  showArrows: bool,
  showBullets: bool,
  clickType: string,
  leftArrow: node,
  rightArrow: node,
  currentIndex: number,
  setCurrentIndex: func
};
Carousel.displayName = "Carousel";

Carousel.defaultProps = {
  showArrows: true,
  showBullets: true,
  currentIndex: 0,
  slidesToShow: 1
};

export default Carousel;
